import "./ButterflyEffect.css";

const BUTTERFLY_CONFIGS = [
  {
    // Orange Butterfly
    id: "orange",
    flightClass: "bfly-flight-1",
    gradStart: "#ff3d00",
    gradMid: "#ff9100",
    gradEnd: "#ffd200",
    glow: "rgba(255, 145, 0, 0.75)",
    sparkleColor: "#ffaa00",
  },
  {
    // Electric Blue Butterfly
    id: "blue",
    flightClass: "bfly-flight-2",
    gradStart: "#0052d4",
    gradMid: "#00b4db",
    gradEnd: "#00f2fe",
    glow: "rgba(0, 180, 219, 0.75)",
    sparkleColor: "#00d2d3",
  },
  {
    // Royal Magenta / Violet Butterfly
    id: "violet",
    flightClass: "bfly-flight-3",
    gradStart: "#8e2de2",
    gradMid: "#e056fd",
    gradEnd: "#ff758c",
    glow: "rgba(224, 86, 253, 0.75)",
    sparkleColor: "#f368e0",
  },
];

let instanceCounter = 0;

function createButterflyElement(config, uniqueId) {
  const creature = document.createElement("div");
  creature.className = `bfly-creature ${config.flightClass}`;

  creature.innerHTML = `
    <div class="bfly-body-wrap">
      <svg class="bfly-wing-left" viewBox="0 0 16 22" width="15" height="21" aria-hidden="true">
        <defs>
          <linearGradient id="bfly-lgrad-${uniqueId}" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="${config.gradStart}" />
            <stop offset="55%" stop-color="${config.gradMid}" />
            <stop offset="100%" stop-color="${config.gradEnd}" />
          </linearGradient>
        </defs>
        <path d="M16 11 C14 4, 7 0, 1 1 C-2 7, 2 12, 11 13 C2 15, 0 18, 2 21 C8 22, 14 17, 16 11 Z" fill="url(#bfly-lgrad-${uniqueId})" filter="drop-shadow(0 0 3px ${config.glow})" />
        <path d="M14 11 Q8 7 3 4 M13 12 Q7 12 3 10 M14 12 Q8 16 4 18" stroke="rgba(255,255,255,0.4)" stroke-width="0.6" fill="none" />
      </svg>
      <svg class="bfly-body" viewBox="0 0 6 22" width="4" height="21" aria-hidden="true">
        <ellipse cx="3" cy="12" rx="1.1" ry="5.5" fill="#1f1815" />
        <circle cx="3" cy="5" r="1.3" fill="#1f1815" />
        <path d="M2.5 4 Q0 1, -1 -1" stroke="#1f1815" stroke-width="0.6" fill="none" stroke-linecap="round" />
        <path d="M3.5 4 Q6 1, 7 -1" stroke="#1f1815" stroke-width="0.6" fill="none" stroke-linecap="round" />
      </svg>
      <svg class="bfly-wing-right" viewBox="0 0 16 22" width="15" height="21" aria-hidden="true">
        <defs>
          <linearGradient id="bfly-rgrad-${uniqueId}" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="${config.gradStart}" />
            <stop offset="55%" stop-color="${config.gradMid}" />
            <stop offset="100%" stop-color="${config.gradEnd}" />
          </linearGradient>
        </defs>
        <path d="M0 11 C2 4, 9 0, 15 1 C18 7, 14 12, 5 13 C14 15, 16 18, 14 21 C8 22, 2 17, 0 11 Z" fill="url(#bfly-rgrad-${uniqueId})" filter="drop-shadow(0 0 3px ${config.glow})" />
        <path d="M2 11 Q8 7 13 4 M3 12 Q9 12 13 10 M2 12 Q8 16 12 18" stroke="rgba(255,255,255,0.4)" stroke-width="0.6" fill="none" />
      </svg>
    </div>
  `;

  return creature;
}

export function triggerButterflyEffect(event) {
  try {
    if (typeof document === "undefined") return;

    let posX = window.innerWidth / 2;
    let posY = window.innerHeight / 2;

    if (event && typeof event.clientX === "number" && event.clientX > 0) {
      posX = event.clientX;
      posY = event.clientY;
    } else if (event && event.currentTarget && typeof event.currentTarget.getBoundingClientRect === "function") {
      const rect = event.currentTarget.getBoundingClientRect();
      posX = rect.left + rect.width / 2;
      posY = rect.top + rect.height / 2;
    } else if (event && event.target && typeof event.target.getBoundingClientRect === "function") {
      const rect = event.target.getBoundingClientRect();
      posX = rect.left + rect.width / 2;
      posY = rect.top + rect.height / 2;
    }

    const portal = document.createElement("div");
    portal.className = "bfly-portal";

    instanceCounter += 1;
    const baseId = `inst-${Date.now()}-${instanceCounter}`;

    // Spawn 3 distinct small butterflies (Orange, Blue, Violet)
    BUTTERFLY_CONFIGS.forEach((config, idx) => {
      const uniqueId = `${baseId}-${config.id}-${idx}`;
      const creature = createButterflyElement(config, uniqueId);
      creature.style.left = `${posX - 17}px`;
      creature.style.top = `${posY - 12}px`;
      portal.appendChild(creature);

      // Create 2-3 delicate trailing sparkles for each butterfly
      for (let s = 0; s < 3; s += 1) {
        const sparkle = document.createElement("div");
        sparkle.className = "bfly-sparkle-dot";
        sparkle.style.backgroundColor = config.sparkleColor;
        sparkle.style.left = `${posX + (Math.random() * 20 - 10)}px`;
        sparkle.style.top = `${posY + (Math.random() * 20 - 10)}px`;
        sparkle.style.setProperty("--dx", `${(Math.random() * 60 - 30)}px`);
        sparkle.style.setProperty("--dy", `${-(Math.random() * 50 + 20)}px`);
        sparkle.style.animationDelay = `${s * 0.15}s`;
        portal.appendChild(sparkle);
      }
    });

    document.body.appendChild(portal);

    // Auto cleanup after 2.6 seconds (2/3 second duration)
    setTimeout(() => {
      if (portal && portal.parentNode) {
        portal.parentNode.removeChild(portal);
      }
    }, 2600);
  } catch (err) {
    console.error("Butterfly effect error:", err);
  }
}

